export class RoleModel {
    id: string | undefined;
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    isChecked: boolean | undefined;
}